module.exports = __webpack_public_path__ + "static/media/kantoushan2.94cb7ada.webp";